<template>
  <section class="ws-fin-list-section ws-fin-contas-pagar">
    <div class="ws-fin-list-head">
      <div class="ws-fin-list-head__left">
        <span class="ws-fin-list-head__icon ws-fin-list-head__icon--out" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
        </span>
        <div>
          <h2 class="ws-fin-list-head__title">{{ t('workspaceFinanceiroServicos.contasPagar.title') }}</h2>
          <p class="ws-fin-list-head__sub">{{ t('workspaceFinanceiroServicos.contasPagar.sub') }}</p>
        </div>
      </div>
      <button type="button" class="ws-fin-filters__apply" @click="openForm()">{{ t('workspaceFinanceiroServicos.contasPagar.add') }}</button>
    </div>
    <div class="ws-fin-contas-pagar__kpis">
      <div class="ws-fin-contas-pagar__kpi">
        <span>{{ t('workspaceFinanceiroServicos.contasPagar.aberto') }}</span>
        <MoneyAmount :value="resumo.aberto" size="sm" />
      </div>
      <div class="ws-fin-contas-pagar__kpi">
        <span>{{ t('workspaceFinanceiroServicos.contasPagar.atrasado') }}</span>
        <MoneyAmount :value="resumo.atrasado" size="sm" />
      </div>
      <div class="ws-fin-contas-pagar__kpi">
        <span>{{ t('workspaceFinanceiroServicos.contasPagar.pagoMes') }}</span>
        <MoneyAmount :value="resumo.pagoMes" size="sm" />
      </div>
    </div>
    <div v-if="!contas.length" class="ws-fin-state ws-fin-state--empty">
      <div class="ws-fin-state__icon" aria-hidden="true">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
      </div>
      <p>{{ t('workspaceFinanceiroServicos.contasPagar.empty') }}</p>
    </div>
    <div v-else class="ws-fin-list-body ws-fin-list-body--cards">
      <WorkspaceContaPagarRow
        v-for="c in contas"
        :key="c.id"
        :conta="c"
        @marcar-pago="$emit('marcar-pago', $event)"
        @desmarcar-pago="$emit('desmarcar-pago', $event)"
        @delete="$emit('delete', $event)"
      />
    </div>

    <div
      v-if="showForm"
      class="ws-fin-modal-overlay"
      role="presentation"
      @click.self="showForm = false"
    >
      <div
        class="ws-fin-modal ws-fin-modal--premium"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ws-fin-conta-modal-title"
        @click.stop
      >
        <header class="ws-fin-modal__header">
          <span class="ws-fin-modal__header-icon ws-fin-modal__header-icon--out" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
          </span>
          <div class="ws-fin-modal__header-text">
            <h3 id="ws-fin-conta-modal-title" class="ws-fin-modal__title">
              {{ editingId ? t('workspaceFinanceiroServicos.contasPagar.edit') : t('workspaceFinanceiroServicos.contasPagar.add') }}
            </h3>
            <p class="ws-fin-modal__subtitle">
              {{ editingId ? t('workspaceFinanceiroServicos.contasPagar.editSub') : t('workspaceFinanceiroServicos.contasPagar.addSub') }}
            </p>
          </div>
          <button type="button" class="ws-fin-modal__close" :aria-label="t('common.close')" @click="showForm = false">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </header>

        <div class="ws-fin-modal__body">
          <label class="ws-fin-modal__field ws-fin-modal__field--full">
            <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.contasPagar.nome') }}</span>
            <input
              v-model="form.nome"
              type="text"
              class="ws-fin-modal__input ws-fin-modal__input--block"
              :placeholder="t('workspaceFinanceiroServicos.contasPagar.nomePlaceholder')"
            />
          </label>

          <div class="ws-fin-modal__grid">
            <label class="ws-fin-modal__field">
              <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.contasPagar.valor') }}</span>
              <div class="ws-fin-modal__input-wrap ws-fin-modal__input-wrap--money">
                <img :src="moneyIcon" alt="" class="ws-fin-modal__money-icon" aria-hidden="true" />
                <input
                  v-model="form.valor"
                  type="number"
                  step="0.01"
                  min="0"
                  class="ws-fin-modal__input"
                  :placeholder="t('workspaceFinanceiroServicos.movimentoValorPlaceholder')"
                />
              </div>
            </label>
            <label class="ws-fin-modal__field">
              <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.contasPagar.vencimento') }}</span>
              <div class="ws-fin-modal__input-wrap">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                <input v-model="form.dataVencimento" type="date" class="ws-fin-modal__input" />
              </div>
            </label>
          </div>

          <label class="ws-fin-modal__field ws-fin-modal__field--full">
            <span class="ws-fin-modal__label">{{ t('workspaceFinanceiroServicos.movimentoDesc') }}</span>
            <input
              v-model="form.descricao"
              type="text"
              class="ws-fin-modal__input ws-fin-modal__input--block"
              :placeholder="t('workspaceFinanceiroServicos.contasPagar.descPlaceholder')"
            />
          </label>

          <div v-if="!editingId" class="ws-fin-modal__rec-block">
            <button
              type="button"
              class="ws-fin-modal__rec-card"
              :class="{ 'ws-fin-modal__rec-card--active': form.isMensal }"
              @click="form.isMensal = !form.isMensal"
            >
              <span class="ws-fin-modal__rec-card__icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                </svg>
              </span>
              <span class="ws-fin-modal__rec-card__text">
                <strong>{{ t('workspaceClienteModal.financeiro.mensalToggle') }}</strong>
                <small>{{ t('workspaceClienteModal.financeiro.mensalSub') }}</small>
              </span>
              <span class="ws-fin-modal__rec-card__switch" :aria-pressed="form.isMensal" />
            </button>

            <div v-if="form.isMensal" class="ws-fin-modal__rec-body">
              <span class="ws-fin-modal__rec-body-label">{{ t('workspaceClienteModal.financeiro.mensalModoLabel') }}</span>
              <div class="ws-fin-modal__rec-modes" role="radiogroup" :aria-label="t('workspaceClienteModal.financeiro.mensalModoLabel')">
                <button
                  type="button"
                  class="ws-fin-modal__rec-mode-btn"
                  :class="{ 'ws-fin-modal__rec-mode-btn--active': form.recMode === 'vezes' }"
                  @click="form.recMode = 'vezes'"
                >
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                  {{ t('workspaceClienteModal.financeiro.mensalVezes') }}
                </button>
                <button
                  type="button"
                  class="ws-fin-modal__rec-mode-btn"
                  :class="{ 'ws-fin-modal__rec-mode-btn--active': form.recMode === 'sempre' }"
                  @click="form.recMode = 'sempre'"
                >
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
                  {{ t('workspaceClienteModal.financeiro.mensalSempre') }}
                </button>
              </div>

              <div v-if="form.recMode === 'vezes'" class="ws-fin-modal__rec-qty">
                <label class="ws-fin-modal__rec-qty-label" for="ws-fin-conta-rec-qty">{{ t('workspaceClienteModal.financeiro.mensalQuantidade') }}</label>
                <div class="ws-fin-modal__qty-wrap">
                  <button type="button" class="ws-fin-modal__qty-step" :disabled="form.repeticoes <= 2" @click="bumpRepeticoes(-1)">−</button>
                  <input id="ws-fin-conta-rec-qty" v-model.number="form.repeticoes" type="number" min="2" max="120" class="ws-fin-modal__qty-input" />
                  <button type="button" class="ws-fin-modal__qty-step" :disabled="form.repeticoes >= 120" @click="bumpRepeticoes(1)">+</button>
                  <span class="ws-fin-modal__qty-suffix">{{ t('workspaceClienteModal.financeiro.mensalMesesSuffix') }}</span>
                </div>
              </div>

              <p v-else class="ws-fin-modal__rec-hint">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                {{ t('workspaceClienteModal.financeiro.mensalSempreHint') }}
              </p>
            </div>
          </div>
        </div>

        <footer class="ws-fin-modal__footer">
          <button type="button" class="ws-fin-modal__btn ws-fin-modal__btn--ghost" @click="showForm = false">{{ t('common.cancel') }}</button>
          <button type="button" class="ws-fin-modal__btn ws-fin-modal__btn--primary ws-fin-modal__btn--out" :disabled="saving" @click="save">{{ t('common.save') }}</button>
        </footer>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'
import WorkspaceContaPagarRow from './WorkspaceContaPagarRow.vue'
import moneyIcon from '@/assets/money-icon.png'
import { hojeISO } from '@/utils/financeiroServicosMetrics'

const props = defineProps({
  contas: { type: Array, default: () => [] },
  workspaceId: { type: Number, required: true },
  onSave: { type: Function, required: true }
})

const emit = defineEmits(['refresh', 'marcar-pago', 'desmarcar-pago', 'delete'])

const { t } = useI18n()
const showForm = ref(false)
const saving = ref(false)
const editingId = ref(null)
const emptyForm = () => ({
  nome: '',
  valor: '',
  dataVencimento: hojeISO(),
  descricao: '',
  isMensal: false,
  recMode: 'vezes',
  repeticoes: 12
})

const form = ref(emptyForm())

const resumo = computed(() => {
  const hoje = hojeISO()
  let aberto = 0
  let atrasado = 0
  let pagoMes = 0
  const mes = hoje.slice(0, 7)
  for (const c of props.contas) {
    const v = Number(c.valor) || 0
    if (!c.isPago) {
      aberto += v
      if (c.dataVencimento && c.dataVencimento < hoje) atrasado += v
    } else if (c.dataPagamento && String(c.dataPagamento).startsWith(mes)) {
      pagoMes += v
    }
  }
  return { aberto, atrasado, pagoMes }
})

function bumpRepeticoes (delta) {
  const next = Math.min(120, Math.max(2, Number(form.value.repeticoes || 2) + delta))
  form.value.repeticoes = next
}

function openForm (conta = null) {
  editingId.value = conta?.id || null
  form.value = conta
    ? { nome: conta.nome, valor: conta.valor, dataVencimento: conta.dataVencimento, descricao: conta.descricao || '', isMensal: !!conta.isMensal, recMode: 'vezes', repeticoes: 12 }
    : emptyForm()
  showForm.value = true
}

async function save () {
  const payload = {
    id: editingId.value,
    workspaceId: props.workspaceId,
    nome: form.value.nome?.trim(),
    valor: Number(form.value.valor),
    dataVencimento: form.value.dataVencimento,
    descricao: form.value.descricao,
    isMensal: form.value.isMensal
  }
  if (!editingId.value && form.value.isMensal) {
    payload.recorrenciaSempre = form.value.recMode === 'sempre'
    payload.repeticoes = form.value.recMode === 'vezes' ? form.value.repeticoes : null
  }
  saving.value = true
  try {
    await props.onSave(payload)
    showForm.value = false
  } catch {
    /* erro exibido pelo handler da página */
  } finally {
    saving.value = false
  }
}
</script>
